<template>
    <div>
        <consult-list :user-type="userTypes.lawyer" :open-id="openId" ></consult-list>
        <van-tabbar v-model="active">
            <van-tabbar-item  icon="home-o">记录</van-tabbar-item>
            <van-tabbar-item  icon="chat-o">我的回复</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
  import ConsultList from './ConsultList';
  import {userTypes} from '../../common/const'
  export default {
    name: "ConsultReply",
    components: {
      ConsultList
    },
    data() {
      return {
        active: 0,
        userTypes,
      }
    },

    computed:{
      openId(){
        if(this.active===0){
          return null
        }else {
          return  this.$store.state.user.openId
        }
      }
    }

  }
</script>

<style scoped>

</style>